import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerAccessPointComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Access Point"} />
            <div className="drawerComponentContainer">
                <DrawerRemoveObjectComponent
                    classes={"mt-35 onlyDesktop"}
                    type={CurrentDrawerOpenType.AccessPoint}
                    payload=""
                    icon={false}
                />
            </div>
        </>
    );
};

export default DrawerAccessPointComponent;
